module.exports = __webpack_public_path__ + "img/6.035b09b4.png";